module.exports = __webpack_public_path__ + "img/fu0004.8206fa72.webp";